export enum UnauthenticatedRoutes {
  Initial = "Initial",
  Register = "Register",
  SSOError = "SSOError",
  ResetPassword = "ResetPassword",
}
